import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { OrganisationTransactionsSummaryContainer } from '~features/finances';

import Page from '../page';

const OrganisationTransactionsSummaryPage = () => {
	const { t } = useTranslation();
	const { date } = useParams();

	const date2 = date != null ? new Date(date) : new Date();

	return (
		<Page title={t('transactions')}>
			<OrganisationTransactionsSummaryContainer date={date2} />
		</Page>
	);
};

export default OrganisationTransactionsSummaryPage;
